<template>
    <div class="wap">
        this is a  page {{this.$store.state.count}}
        <div class="page">dkfhdhf </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.wap{
    .page{
        color: red;
    }
}
</style>